var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 31,
    viewBox: "0 0 120 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1463_3727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H5.02641V24.4528H0V0Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0972 0H8.0708V4.65297H13.0972V0Z",
    fill: "#19B5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0972 6.54712H8.0708V24.4594H13.0972V6.54712Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1744 0V8.57334H21.2738C21.5347 7.91995 23.2868 6.19736 26.2691 6.19736C30.0964 6.19736 34.3089 9.25974 34.3089 15.4967C34.3089 21.7337 30.0964 24.796 26.2691 24.796C23.2868 24.796 21.5347 23.0735 21.2738 22.4201H21.1744V24.4528H16.1479V0H21.1744ZM25.2253 20.0441C27.3626 20.0441 29.3446 18.3875 29.3446 15.4967C29.3446 12.6059 27.3688 10.9493 25.2253 10.9493C23.0818 10.9493 21.0439 12.5663 21.0439 15.4967C21.0439 18.4271 23.0196 20.0441 25.2253 20.0441Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7314 15.5362C35.7314 9.47744 39.9812 6.20386 44.3242 6.20386C48.6671 6.20386 53.6314 9.37184 52.5628 17.569H40.5652C41.2487 19.4962 42.9324 20.4598 45.1692 20.4598C46.6603 20.4598 47.9899 20.0836 49.2201 19.0804L51.4879 21.595C50.0962 23.4561 47.6917 24.7959 44.6162 24.7959C39.9439 24.7959 35.7314 21.4234 35.7314 15.5296V15.5362ZM48.1515 13.741C47.7973 11.6752 46.0763 10.6786 44.3925 10.6786C42.7088 10.6786 41.0188 11.6092 40.472 13.741H48.1577H48.1515Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9609 6.54706H59.9873V11.4046C60.5403 8.51384 62.1619 6.20386 65.2064 6.20386C65.5978 6.20386 65.983 6.23686 66.4055 6.37546V11.4376C66.0141 11.3716 65.6599 11.332 65.2374 11.332C61.8948 11.332 59.9873 13.708 59.9873 17.0872V24.4593H54.9609V6.54706Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5139 24.2482L67.5117 6.54712H72.6375L76.9184 18.1894L81.1992 6.54712H86.325L79.2545 24.4594L76.6636 31.0066H71.7366L74.5263 24.2548L74.5139 24.2482Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.797 24.4528H99.7703V22.1824C98.8321 23.7004 97.1794 24.8026 94.775 24.8026C91.3702 24.8026 88.4873 22.5652 88.4873 17.0873V6.54712H93.5137V16.1567C93.5137 18.394 94.5824 20.0506 96.6575 20.0506C98.7327 20.0506 99.7703 18.394 99.7703 16.1567V6.54712H104.797V24.4594V24.4528Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.872 19.7008L110.861 18.5656C111.122 19.4236 111.706 20.6314 113.29 20.6314C114.197 20.6314 115.042 20.1496 115.042 19.153C115.042 18.5656 114.719 18.0178 113.613 17.635L111.345 16.7374C108.556 15.6682 107.357 13.741 107.357 11.5036C107.357 8.16405 110.177 6.19727 113.483 6.19727C116.788 6.19727 118.963 8.09145 119.547 10.9822L115.626 12.0184C115.204 10.639 114.359 10.3288 113.682 10.3288C112.706 10.3288 112.221 10.9492 112.221 11.5696C112.221 12.157 112.545 12.7048 113.682 13.0876L115.788 13.9126C117.602 14.566 120 15.9124 120 19.1464C120 22.7632 117.117 24.7959 113.352 24.7959C109.947 24.7959 107.388 23.1064 106.866 19.7008H106.872Z",
    fill: "#2C3E50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1463_3727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.74574000f738d1928dddead8c615e967.svg";
export { ForwardRef as ReactComponent };